import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: "fui-video",
    templateUrl: "./video.component.html",
    styleUrls: ["./video.component.scss"],
    standalone: false
})
export class FUIVideoComponent implements OnInit {
    @Input() video: string;

    constructor() {
    }

    ngOnInit() {
    }
}
